// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";

export class TermsOfServicePage extends React.Component {
  render(): React.ReactNode {
    return (
      <div>
        Terms of Service
      </div>
    )
  }
}
